<template>
    <div v-if="!auth" class="mailform">
        <v-form class="formular" ref="form" v-model="valid" lazy-validation>
            <strong
                    class="text-h5 font-weight-bold text-center white--text"
            >Komplette Wissensdatenbank freischalten</strong>
            <p
                    class="white--text mt-4"
            >Wir haben das gesamte Thema Sales 4.0 - Digitalisierung im Vertrieb - in vier aufeinander aufbauende Module
                unterteilt. Durch diese Vorgehensweise konnte die enra GmbH ihren Vertriebsprozess innerhalb weniger
                Wochen anpassen. Resultat: automatisierte Leadgenerierung, spannendes Contentmarketing und vieles
                mehr. </p>
            <v-text-field solo v-model="email" :rules="emailRules" class="mt-8" label="E-Mail" required></v-text-field>
            <v-checkbox
                    dark
                    v-model="checkbox"
                    :rules="[v => !!v || 'Stimmen Sie dem Datenschutz zu, um die Wissensdatenbank freizuschalten']"
                    label="Datenschutz zustimmen"
                    required
            ></v-checkbox>
            <v-card-actions>
                <v-btn color="third" class="white--text mb-5" @click="validate">Absenden</v-btn>
                <p class="errorHere white--text ml-3"></p>
            </v-card-actions>
            <v-progress-circular
                    v-if="successBol"
                    indeterminate
                    color="red"
            ></v-progress-circular>
            <v-alert v-if="successBol" class="successHere" type="success">Sie erhalten in Kürze eine Mail von uns</v-alert>
            <v-alert v-show="errorBol" class="errorHere" type="error"></v-alert>
        </v-form>
    </div>
</template>

<script>
    import firebase from "firebase";

    export default {
        data: () => ({
            successBol: false,
            errorBol: false,
            auth: false,
            valid: true,
            submitted: false,
            checkbox: false,
            email: "",
            emailRules: [
                (v) => !!v || "E-Mail benötigt.",
                (v) => /.+@.+\..+/.test(v) || "Bitte geben Sie eine gültige E-Mail ein.",
            ],
        }),
        mounted() {
            firebase.auth().onAuthStateChanged((user) => {
                this.auth = !!user;
            });
        },
        methods: {
            validate() {
                if (this.$refs.form.validate()) {
                    if (this.email.length && this.checkbox === true) {
                        const kursAnmeldung = firebase
                            .functions()
                            .httpsCallable("kursAnmeldung");
                        kursAnmeldung({
                            email: this.email,
                        })
                            .then(() => {
                                this.successBol = true;
                                this.errorBol = false;
                                // console.log("sent successfully");
                                setTimeout(() => {
                                    document.querySelector(".successHere").textContent = "";
                                    this.successBol = false;
                                    this.$refs.form.reset();
                                    // console.log("I AM DONE");
                                }, 10000);
                            })
                            .catch((err) => {
                                this.errorBol = true;
                                document.querySelector(".errorHere").textContent = err.message;
                            });
                    }
                }
            },
        },
    };
</script>

<style scoped>
    .mailform {
        background-color: #203048;
        text-align: center;
        padding: 3em 0;
        width: 100%;
    }

    .formular {
        width: 80%;
        margin-left: auto;
        margin-right: auto;
    }

    .v-progress-circular {
        margin: 1rem;
    }

    @media only screen and (min-width: 992px) {
        .formular {
            width: 55%;
        }
        .mailform {
            /*padding: 80px;*/
        }
    }
</style>